/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetMerchantOrgBlockList200ResponseInner
 */
export interface GetMerchantOrgBlockList200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'patternType': GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'storeType': GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMerchantOrgBlockList200ResponseInner
     */
    'createdAt': string;
}

export const GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum = typeof GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum[keyof typeof GetMerchantOrgBlockList200ResponseInnerPatternTypeEnum];
export const GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum = typeof GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum[keyof typeof GetMerchantOrgBlockList200ResponseInnerStoreTypeEnum];


